export type CreditScoreBand = 'Poor' | 'Fair' | 'Good' | 'Very Good' | 'Excellent';
export type DebtType = 'credit_card' | 'medical' | 'education' | 'personal';
export type DebtRisk = 'low' | 'medium' | 'high';
export type BillRisk = 'overdue' | 'due_soon' | 'upcoming' | 'normal';
export type InsightSeverity = 'info' | 'warn' | 'danger';
export type DtiRisk = 'low' | 'moderate' | 'high' | 'very_high';

export interface CreditTrendPoint {
  month: string;   // e.g. "Jan 24"
  score: number;   // 300–850
}

export interface CreditHealth {
  score: number;
  band: CreditScoreBand;
  lastUpdated: string;              // ISO date string
  trend: CreditTrendPoint[];        // 12 monthly entries, oldest first
  utilizationPct: number;           // 0–100
  onTimePaymentPct: number;         // 0–100
  recentChanges: string[];          // human-readable factor notes
}

export interface DebtItem {
  id: string;
  lender: string;
  type: DebtType;
  balance: number;       // USD
  apr: number | null;    // percentage, e.g. 19.99
  minPayment: number | null;
  risk: DebtRisk;
}

export interface IncomeSource {
  label: string;
  amount: number;        // monthly USD
}

export interface AssetCategory {
  category: string;
  value: number;         // USD
}

export interface Bill {
  id: string;
  name: string;
  category: string;
  amount: number;        // USD
  dueDate: string;       // ISO date string
  risk: BillRisk;
}

export interface FinancialInsight {
  id: string;
  icon: string;          // pi pi-* class
  title: string;
  body: string;
  suggestedAction: string;
  severity: InsightSeverity;
}

export interface ClientFinancesState {
  creditHealth: CreditHealth;
  debts: DebtItem[];
  dti: number;                      // 0–1 ratio
  monthlyIncome: number;            // USD
  incomeSources: IncomeSource[];
  assets: AssetCategory[];
  emergencySavings: number;         // USD
  monthlyExpenses: number;          // USD
  bills: Bill[];
  insights: FinancialInsight[];
}
